module.exports = __webpack_public_path__ + "static/assets/83422ef12b72581533bb197b6e0803fc.svg";